module.exports = __webpack_public_path__ + "static/chat-support-a008509e540c4da0b13e8c2abd6943d5.png";